'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _chunk = require('lodash/chunk');var _chunk2 = _interopRequireDefault(_chunk);
var _CollapsibleGrid = require('./CollapsibleGrid.scss');var _CollapsibleGrid2 = _interopRequireDefault(_CollapsibleGrid);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

CollapsibleGrid = function (_Component) {_inherits(CollapsibleGrid, _Component);function CollapsibleGrid() {var _temp, _this, _ret;_classCallCheck(this, CollapsibleGrid);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      collapsed: false }, _this.


    renderLink = function (link, name, tag) {
      var handleClick = function handleClick() {return _this.props.handleClick(tag);};

      return (
        _react2.default.createElement(_reactRouter.Link, { key: link, onClick: handleClick /* to={appendLocale(this.props.locale, `/${link}`)} */ },
          name));


    }, _temp), _possibleConstructorReturn(_this, _ret);}CollapsibleGrid.prototype.

  renderGrid = function renderGrid(data, withButton) {var _this2 = this;
    return (
      _react2.default.createElement('div', { className: _CollapsibleGrid2.default.gridWrapper },
        data.map(function (row, idx) {return (
            // eslint-disable-next-line react/no-array-index-key
            _react2.default.createElement('div', { key: 'row-' + idx, className: _CollapsibleGrid2.default.innerRow },
              row.map(function (item) {return (
                  _react2.default.createElement('span', { key: item.name },
                    _this2.renderLink(item.url, item.name, item.tag)));})));}),




        withButton ?
        _react2.default.createElement('div', null,
          _react2.default.createElement('button', { key: 'moreButton', onClick: function onClick() {return _this2.setState({ collapsed: true });} },
            this.props.moreButtonText)) :

        null));

  };CollapsibleGrid.prototype.

  renderAll = function renderAll() {
    var chunked = (0, _chunk2.default)(this.props.data, 2);
    return this.renderGrid(chunked, false);
  };CollapsibleGrid.prototype.

  renderPartial = function renderPartial() {
    var data = this.props.data ? this.props.data.slice(0, this.props.heightLimit * 2) : [];
    var chunked = (0, _chunk2.default)(data, 2);
    return this.renderGrid(chunked, true);
  };CollapsibleGrid.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: _CollapsibleGrid2.default.wrapper },
        _react2.default.createElement('div', { className: _CollapsibleGrid2.default.header }, this.props.header),
        this.state.collapsed ? this.renderAll() : this.renderPartial()));


  };return CollapsibleGrid;}(_react.Component);exports.default = CollapsibleGrid;


CollapsibleGrid.propTypes = {
  handleClick: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  header: _propTypes2.default.string,
  data: _propTypes2.default.array,
  moreButtonText: _propTypes2.default.string,
  heightLimit: _propTypes2.default.number // rows number
};

CollapsibleGrid.defaultProps = {
  heightLimit: 3 };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CollapsibleGrid/CollapsibleGrid.js
// module id = 2634
// module chunks = 0